import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//

import VMask from './VMask';
import { mapActions } from 'vuex';
import { TOGGLE_PROMPT } from '@/constants/detail';
export default {
  name: 'widget__popup',
  props: {
    confirm: Function,
    text: {
      type: String,
      default: '确定'
    }
  },
  methods: Object.assign({}, mapActions([TOGGLE_PROMPT])),
  components: {
    'v-mask': VMask
  }
};